import React, { useState } from 'react';
import TweenOne from 'rc-tween-one';
import { Menu, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import logo from '@/static/logo_1.png';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
// import './header.less';
import { getChildrenToRender } from '@/utils';

const langOptions = [
  {
    label: '简体中文',
    value: 'zh'
  },
  {
    label: 'English',
    value: 'en'
  }
];

const { Item, SubMenu } = Menu;

export default function Header({ dataSource, isFirstScreen, isMobile, ...props }) {
  const [phoneOpen, setPhoneOpen] = useState(undefined);
  const [current, setCurrent] = useState('index');
  const { t, i18n } = useTranslation();

  const phoneClick = () => {
    setPhoneOpen(!phoneOpen);
  };

  const navData = dataSource.Menu.children;
  const navChildren = navData.map((item) => {
    const { children: a, subItem, ...itemProps } = item;

    // 有子项
    if (subItem) {
      return (
        <SubMenu
          key={item.name}
          {...itemProps}
          title={
            <div
              {...a}
              className={`header0-item-block ${a.className}`.trim()}
            >
              {a.children.map((value, index) => getChildrenToRender(value, index, t))}
            </div>
          }
          popupClassName="header0-item-child"
        >
          {subItem.map(($item, ii) => {
            const { children: childItem } = $item;
            const child = childItem.href ? (
              <a {...childItem}>
                {childItem.children.map((value, index) => getChildrenToRender(value, index, t))}
              </a>
            ) : (
              <div {...childItem}>
                {childItem.children.map((value, index) => getChildrenToRender(value, index, t))}
              </div>
            );
            return (
              <Item key={$item.name || ii.toString()} {...$item}>
                {child}
              </Item>
            );
          })}
        </SubMenu>
      );
    }
    // 没有子项
    return (
      <Item key={item.name} {...itemProps}>
        <a {...a} className={`header0-item-block ${a.className}`.trim()}>
          {a.children.map((value, index) => getChildrenToRender(value, index, t))}
        </a>
      </Item>
    );
  });
  const moment = phoneOpen === undefined ? 300 : null;
  const color = isFirstScreen ? '#000' : '#000';
  const pos = isMobile ? { top: 15, right: 40 } : { top: 20, right: -60, fontSize: 14 };

  return (
    <div className={`${isFirstScreen ? 'home-nav-white' : 'home-nav-white'}`}
         style={{ position: 'fixed', width: '100%', zIndex: 1000, top: 0 }}>
      <TweenOne
        component="header"
        animation={{ opacity: 0, type: 'from' }}
        className="header0 home-page-wrapper"
        {...props}
      >
        <div
          className={`home-page ${phoneOpen ? ' open' : ''}`}
        >
          <TweenOne
            animation={{ x: -30, type: 'from', ease: 'easeOutQuad' }}
            className="header0-logo"
          >
            <a href="/home">
              <img width="100%" src={logo} alt="logo" />
            </a>
          </TweenOne>
          {isMobile && (
            <div
              className="header0-mobile-menu"
              onClick={() => {
                phoneClick();
              }}
            >
              <em />
              <em />
              <em />
            </div>
          )}
          <TweenOne
            className="header0-menu"
            animation={
              isMobile
                ? {
                  height: 0,
                  duration: 300,
                  onComplete: (e) => {
                    if (phoneOpen) {
                      e.target.style.height = 'auto';
                    }
                  },
                  ease: 'easeInOutQuad'
                }
                : null
            }
            moment={moment}
            reverse={!!phoneOpen}
          >
            <Menu
              mode={isMobile ? 'inline' : 'horizontal'}
              // defaultSelectedKeys={['index']}
              onClick={(e) => {
                console.log(e);
                setCurrent(e.key);
              }}
              selectedKeys={[current]}
              id="nav"
            >
              {navChildren}
            </Menu>
          </TweenOne>
          {/*<TweenOne
            style={{ position: 'absolute', ...pos }}
          >
            <GlobalOutlined style={{ color }} />
            <Select
              defaultValue={i18n.language === 'en' ? 'en' : 'zh'}
              style={{ background: 'transparent', color }}
              size="small"
              bordered={false}
              suffixIcon={<DownOutlined style={{ color }} />}
              options={langOptions}
              onChange={(value) => {
                i18n.changeLanguage(value);
              }}
            />
          </TweenOne>*/}
        </div>
      </TweenOne>
    </div>
  );
}

